module.exports = __webpack_public_path__ + "img/car_02.72a4c39a.jpg";